var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseSm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 10,
    viewBox: "0 0 19 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1488_82941",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 0,
    width: 11,
    height: 10
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.66699,
    width: 10,
    height: 10,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1488_82941)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.67723 5.97615L7.85471 7.79557C7.71819 7.93186 7.55436 8 7.36324 8C7.17211 8 7.00829 7.93186 6.87177 7.79557C6.73525 7.65928 6.66699 7.49738 6.66699 7.30985C6.66699 7.12259 6.73525 6.96082 6.87177 6.82453L8.6943 4.99489L6.87177 3.17547C6.73525 3.03918 6.66699 2.87727 6.66699 2.68974C6.66699 2.50249 6.73525 2.34072 6.87177 2.20443C7.00146 2.06814 7.16187 2 7.353 2C7.54413 2 7.70795 2.06814 7.84447 2.20443L9.66699 4.02385L11.4793 2.20443C11.6158 2.06814 11.7796 2 11.9707 2C12.1619 2 12.3257 2.06814 12.4622 2.20443C12.5987 2.34072 12.667 2.50426 12.667 2.69506C12.667 2.88586 12.5987 3.0494 12.4622 3.18569L10.6397 5.00511L12.4622 6.82453C12.5987 6.96082 12.667 7.12436 12.667 7.31516C12.667 7.50596 12.5987 7.6661 12.4622 7.79557C12.3325 7.93186 12.1721 8 11.981 8C11.7899 8 11.6294 7.93186 11.4998 7.79557L9.67723 5.97615Z",
    fill: "#FF5334"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSm);
export default __webpack_public_path__ + "static/media/close_sm.8c82f410cae75523d7a89e1533895416.svg";
export { ForwardRef as ReactComponent };